import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Button} from '../../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {useAppDispatch} from '../../../../../helpers/reduxHelpers';
import {signoutOtherSessionsActionAsync} from '../../../../../store/data/teammates/teammatesActions';

/*
 * Component.
 */

export const SignOutOtherSessionsButton: FC = (props) => {
  const dispatch = useAppDispatch();

  return (
    <Button
      variant={ButtonVariantsEnum.SECONDARY}
      size={VisualSizesEnum.MEDIUM}
      onClick={() => dispatch(signoutOtherSessionsActionAsync())}
    >
      <Trans id="sign-out-other-sessions-button">Sign out other sessions</Trans>
    </Button>
  );
};
